import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/common/nftlogo.png'


const _withScopeId = n => (_pushScopeId("data-v-44fd1dce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "list-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "nft-container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "nft-name-symbol-container"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  src: _imports_0,
  class: "symbol"
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "time-container" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "event-topic" }
const _hoisted_18 = {
  key: 5,
  class: "event-name"
}
const _hoisted_19 = {
  key: 0,
  class: "warning-tag",
  viewBox: "64 64 896 896",
  focusable: "false",
  "data-icon": "exclamation-circle",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z",
  fill: "rgb(218, 67, 67)"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "csv-export-bar"
}

import { computed, watch } from "@vue/runtime-core";
import { useMq } from "vue3-mq";
import { useRouter, useRoute } from "vue-router";

interface Props {
  data: {};
  rowDatas: {};
  total: {};
  handle: {};
  currentPage: number;
  handleCurrentChange: {};
  csvExport: boolean;
  csvGenerating: boolean;
  csvPercentage: number;
  handleCSVExport: {};
  firstColumnWidth: string;
  secondColumnWidth: string;
  thirdColumnWidth: string;
  fourthColumnWidth: string;
  fifthColumnWidth: string;
  sixthColumnWidth: string;
  lastColumnWidth: string;
  txHashColumn: string;
  blockColumn: string;
  fromColumn: string;
  toColumn: string;
  addressColumn: string;
  contractColumn: string;
  tokenIdColumn: string;
  pageSize: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    data: null,
    rowDatas: null,
    total: null,
    handle: { default: null },
    currentPage: { default: null },
    handleCurrentChange: { default: null },
    csvExport: { type: Boolean, default: false },
    csvGenerating: { type: Boolean, default: false },
    csvPercentage: { default: 0 },
    handleCSVExport: { default: null },
    firstColumnWidth: { default: "" },
    secondColumnWidth: { default: "" },
    thirdColumnWidth: { default: "" },
    fourthColumnWidth: { default: "" },
    fifthColumnWidth: { default: "" },
    sixthColumnWidth: { default: "" },
    lastColumnWidth: { default: "" },
    txHashColumn: { default: "" },
    blockColumn: { default: "" },
    fromColumn: { default: "" },
    toColumn: { default: "" },
    addressColumn: { default: "" },
    contractColumn: { default: "" },
    tokenIdColumn: { default: "" },
    pageSize: { default: 10 }
  },
  setup(__props: any) {



const mq = useMq();
const router = useRouter();
const route = useRoute();

const isSP = computed(() => mq.current === "xs");

const toTx = (hash) => {
  router.push({ name: "Tx", params: { Hash: hash } });
};
const toBlock = (blockNumber) => {
  router.push({ name: "Block", params: { Number: blockNumber } });
};
const toAddress = (address) => {
  router.push({
    name: "UserTxs",
    params: {
      User: address.toLowerCase(),
    },
  });
};
const toContract = (nft) => {
  router.push({
    name: "ContractDetail",
    params: {
      Contract: nft,
    },
  });
};
const toNft = (contractAddress, tokenId) => {
  router.push({
    name: "NFTTokenDetail",
    params: { NFT: contractAddress, Token: tokenId },
  });
};

watch(route, () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        data: __props.data,
        onCellClick: __props.handle,
        style: {"width":"100%"},
        "empty-text": "No Data"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowDatas, (rowData, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: rowData.BlockNumber,
              prop: "rowData.prop",
              width: 
              index === 0
                ? __props.firstColumnWidth
                : index === 1
                ? __props.secondColumnWidth
                : index === 2
                ? __props.thirdColumnWidth
                : index === 3
                ? __props.fourthColumnWidth
                : index === 4
                ? __props.fifthColumnWidth
                : index === 5
                ? __props.sixthColumnWidth
                : index === __props.rowDatas.length - 1
                ? __props.lastColumnWidth
                : ''
            
            }, {
              header: _withCtx((headerScope) => [
                _createTextVNode(_toDisplayString(_ctx.$t(rowData.label)), 1)
              ]),
              default: _withCtx((scope) => [
                (_unref(isSP))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(rowData.label)), 1))
                  : _createCommentVNode("", true),
                (rowData.prop === 'Token')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("img", {
                        class: "nft",
                        src: rowData.method(scope.row)
                      }, null, 8, _hoisted_5)
                    ]))
                  : (rowData.prop === 'TokenNameSymbol')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (scope.row.uri)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: scope.row.uri,
                              class: "symbol"
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                        _createTextVNode(" " + _toDisplayString(rowData.method(scope.row)), 1)
                      ]))
                    : (rowData.prop === 'EventTransactionHash')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", {
                            class: "cell-link",
                            onClick: ($event: any) => (toTx(scope.row.TransactionHash))
                          }, _toDisplayString(rowData.method(scope.row)), 9, _hoisted_10),
                          _createElementVNode("div", null, _toDisplayString(rowData.number(scope.row)), 1),
                          _createElementVNode("div", _hoisted_11, [
                            (rowData.timeDifference(scope.row).days > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(rowData.timeDifference(scope.row).days === 1
                        ? `${rowData.timeDifference(scope.row).days} day ago`
                        : `${rowData.timeDifference(scope.row).days} days ago`), 1))
                              : (rowData.timeDifference(scope.row).hours > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(rowData.timeDifference(scope.row).hours === 1
                        ? `${rowData.timeDifference(scope.row).hours} hour ago`
                        : `${rowData.timeDifference(scope.row).hours} hours ago`), 1))
                                : (rowData.timeDifference(scope.row).minutes > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(rowData.timeDifference(scope.row).minutes === 1
                        ? `${
                            rowData.timeDifference(scope.row).minutes
                          } minute ago`
                        : `${
                            rowData.timeDifference(scope.row).minutes
                          } minutes ago`), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(rowData.timeDifference(scope.row).seconds === 1
                        ? `${
                            rowData.timeDifference(scope.row).seconds
                          } second ago`
                        : `${
                            rowData.timeDifference(scope.row).seconds
                          } seconds ago`), 1))
                          ])
                        ]))
                      : (rowData.prop === 'EventLog')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowData.getTopics(scope.row), (topics) => {
                              return (_openBlock(), _createElementBlock("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topics.topicValues, (topicValue, i) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("span", null, _toDisplayString(`[ ${topics.topicNames[i]} ]`), 1),
                                    _createElementVNode("span", null, _toDisplayString(_unref(isSP)
                          ? `${topicValue.substr(0, 8)}...${topicValue.substr(
                              34,
                              8
                            )}`
                          : topicValue), 1)
                                  ]))
                                }), 256))
                              ]))
                            }), 256))
                          ]))
                        : (rowData.prop === 'EventName')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("span", null, _toDisplayString(rowData.name(scope.row)), 1),
                              _createElementVNode("span", null, _toDisplayString(rowData.signature(scope.row.EventId)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 6,
                              class: _normalizeClass(
                  index === __props.txHashColumn
                    ? 'important tx-hash-container'
                    : 'important'
                )
                            }, [
                              (
                    index === __props.txHashColumn &&
                    rowData.status &&
                    rowData.status(scope.row) === 0
                  )
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: _normalizeClass(
                    index === __props.blockColumn ||
                    index === __props.txHashColumn ||
                    (_unref(route).params &&
                      index === __props.fromColumn &&
                      scope.row.From !== _unref(route).params.User) ||
                    (_unref(route).params &&
                      index === __props.toColumn &&
                      scope.row.To !== _unref(route).params.User) ||
                    index === __props.addressColumn ||
                    index === __props.contractColumn ||
                    index === __props.tokenIdColumn
                      ? 'cell-link'
                      : ''
                  ),
                                onClick: ($event: any) => (
                    index === __props.blockColumn
                      ? toBlock(scope.row.BlockNumber)
                      : index === __props.txHashColumn
                      ? toTx(scope.row.Hash || scope.row.TransactionHash)
                      : _unref(route).params &&
                        index === __props.fromColumn &&
                        scope.row.From !== _unref(route).params.User
                      ? _unref(route).params && toAddress(scope.row.From)
                      : index === __props.toColumn && scope.row.To !== _unref(route).params.User
                      ? toAddress(scope.row.To)
                      : index === __props.addressColumn
                      ? toAddress(scope.row.Address)
                      : index === __props.contractColumn
                      ? toContract(scope.row.Contract)
                      : index === __props.tokenIdColumn
                      ? toNft(scope.row.Contract, scope.row.Token)
                      : ''
                  )
                              }, _toDisplayString(rowData.method(scope.row)), 11, _hoisted_22)
                            ], 2))
              ]),
              _: 2
            }, 1032, ["width"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "onCellClick"]),
      (__props.csvExport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (__props.csvGenerating)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_el_progress, {
                    "text-inside": true,
                    "stroke-width": 24,
                    percentage: __props.csvPercentage,
                    color: '#286fff'
                  }, null, 8, ["percentage"])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(__props.data !== null ? 'csv-export' : 'csv-export disabled')
                }, [
                  _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleCSVExport && __props.handleCSVExport(...args))),
                    class: "csv-export-text"
                  }, _toDisplayString(_ctx.$t("list.csvexport")), 1)
                ], 2))
          ]))
        : _createCommentVNode("", true),
      (__props.handleCurrentChange)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 1,
            onCurrentChange: __props.handleCurrentChange,
            layout: _unref(isSP) ? 'prev, next' : 'prev, pager, next',
            "page-size": __props.pageSize,
            total: __props.total,
            "current-page": __props.currentPage
          }, null, 8, ["onCurrentChange", "layout", "page-size", "total", "current-page"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})